import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";
import { reminder } from '../../../model/reminder';

// const sanifyContact = (c: contact): contact => {
//     let s = emptyContact();
//     Object.keys(c).forEach(key => {
//         if (c[key]) {
//             s[key] = c[key];
//         }
//     })
//     return s;
// }

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOADREMINDERS_PENDING: {
            return {
                ...state,
                reminders: [],
                isLoadingReminders: true,
            }
        }
        case Keys.LOADREMINDERS_FULFILLED: {
            let p: Array<reminder> = action.payload;
            return {
                ...state,
                reminders: p,
                isLoadingReminders: false,
            }
        }
        case Keys.LOADREMINDERS_REJECTED: {
            return {
                ...state,
                reminders: [],
                isLoadingReminders: false,
            }
        }
        case Keys.SAVEREMINDER_PENDING: {
            return state;
        }
        case Keys.SAVEREMINDER_FULFILLED: {
            let p: reminder = action.payload; // sanifyContact();

            // REMINDERS
            let reminders = [...state.reminders];
            let found = reminders.findIndex(c => c._id === p._id);
            if (found >= 0) {
                reminders[found] = p;
            }
            else {
                reminders.push(p);
            }

            // CONTACT
            let reminders2 = [...state.selectedContactReminders];
            let found2 = reminders2.findIndex(c => c._id === p._id);
            if (found2 >= 0) {
                reminders2[found2] = p;
            }
            else {
                reminders2.push(p);
            }

            return {
                ...state,
                reminders: reminders,
                selectedContactReminders: reminders2,
                // openDialog: false,
                // selectedTrainer: p,
            }
        }
        case Keys.SAVEREMINDER_REJECTED: {
            return state;
        }
        case Keys.LOADCONTACTSREMINDERS_PENDING: {
            return {
                ...state,
                selectedContactReminders: [],
                isLoadingReminders: true,
            }
        }
        case Keys.LOADCONTACTSREMINDERS_FULFILLED: {
            let p: Array<reminder> = action.payload;
            return {
                ...state,
                selectedContactReminders: p,
                isLoadingReminders: false,
            }
        }
        case Keys.LOADCONTACTSREMINDERS_REJECTED: {
            return {
                ...state,
                selectedContactReminders: [],
                isLoadingReminders: false,
            }
        }
        case Keys.ADDREMINDER_PENDING: {
            return {
                ...state,
                // openDialog: true,
                // selectedTrainer: undefined,
            }
        }
        case Keys.ADDREMINDER_FULFILLED: {
            let p: reminder = action.payload; // sanifyContact();
            
            // REMINDERS
            let reminders = [...state.reminders];
            reminders.push(p);

            // CONTACT
            let reminders2 = [...state.selectedContactReminders];
            reminders2.push(p);
            
            return {
                ...state,
                reminders: reminders,
                selectedContactReminders: reminders2,
            }
        }
        case Keys.ADDREMINDER_REJECTED: {
            return state;
        }
        default:
            return state;
    }
}